import { z } from 'zod';

import { ProbationReviewOutcome } from '@/common/graphql';

const REQUIRED_MESSAGE = 'Select the outcome';

/** There is no default outcome: HRBP must choose Passed or Failed. The comment is optional and exported only. */
export const ProbationReviewRecordOutcomeFormData = z.object({
  outcome: z
    .nativeEnum(ProbationReviewOutcome)
    .nullable()
    .default(null)
    .refine(value => value !== null, { message: REQUIRED_MESSAGE }),
  comment: z.string().default(''),
});
export type ProbationReviewRecordOutcomeFormDataType = z.infer<typeof ProbationReviewRecordOutcomeFormData>;
